module.exports = __webpack_public_path__ + "static/img/20240927_5.944bada.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2024/20240927_5.png
// module id = G92W
// module chunks = 0